import { render, staticRenderFns } from "./Assignment.vue?vue&type=template&id=02d1d80a"
import script from "./Assignment.vue?vue&type=script&lang=js"
export * from "./Assignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02d1d80a')) {
      api.createRecord('02d1d80a', component.options)
    } else {
      api.reload('02d1d80a', component.options)
    }
    module.hot.accept("./Assignment.vue?vue&type=template&id=02d1d80a", function () {
      api.rerender('02d1d80a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/player/components/Assignment.vue"
export default component.exports